<div class="flex mx-auto">
    <form
        class="justify-center mx-auto mt-10 mb-10 flex w-full max-w-sm flex-col rounded-xl bg-white p-6 shadow"
        (submit)="onSubmit($event)"
        role="form"
        aria-labelledby="login-heading"
        aria-describedby="login-desc kassen-hint kassen-error">
        <h1 id="login-heading" class="text-2xl font-bold mb-4">Anmeldung</h1>

        <p id="login-desc" class="mb-6 text-gray-500 text-xs">
            Bitte geben Sie Ihr Kassenzeichen ein, um sich anzumelden. Das Kassenzeichen finden Sie auf Ihren Unterlagen oder in der E-Mail, die Sie von uns erhalten haben.
        </p>

        <div class="mb-6">
            <label id="kassen-label" class="mb-2 text-sm font-bold text-gray-700" for="kassenzeichen">Kassenzeichen</label>
            <div class="flex items-center relative pt-2">
                <input
                    type="text"
                    id="kassenzeichen"
                    placeholder="000000-0000-0000"
                    aria-labelledby="kassen-label"
                    aria-describedby="kassen-hint kassen-error"
                    aria-required="true"
                    class="w-full p-2 pr-8 uppercase input-default"
                    [class.invalid]="loginForm.kassenzeichen().invalid() && loginForm.kassenzeichen().touched()"
                    [formField]="loginForm.kassenzeichen"
                    mask="000000-0000-0000"
                    [showMaskTyped]="true"
                    [attr.aria-invalid]="loginForm.kassenzeichen().invalid() && loginForm.kassenzeichen().touched() ? 'true' : 'false'"
                    />
                <fa-icon [icon]="faPassport" class="absolute right-2 text-gray-500" aria-hidden="true" focusable="false"></fa-icon>
            </div>
            <div id="kassen-hint" class="text-xs text-gray-500 mt-2">Format: 000000-0000-0000</div>
            @if(loginForm.kassenzeichen().invalid() && loginForm.kassenzeichen().touched()) {
              <div id="kassen-error" role="alert" aria-live="assertive" class="text-sm text-red-600 mt-2">Bitte geben Sie ein gültiges Kassenzeichen ein.</div>
            }
            @if(errorMessage()) {
              <div id="kassen-error" role="alert" aria-live="assertive" class="text-sm text-red-600 mt-2">{{ errorMessage() }}</div>
            }
        </div>

        <button
            type="submit"
            class="button-login flex items-center justify-center gap-2"
            [disabled]="!loginForm().valid() || isLoading()"
            [attr.aria-disabled]="!loginForm().valid() || isLoading()"
            [attr.aria-busy]="isLoading()">
            @if (isLoading()) {
              <fa-icon [icon]="faSpinner" animation="spin" aria-hidden="true" focusable="false"></fa-icon>
            }
            Anmelden
        </button>

        <p class="mt-8 text-center text-xs text-gray-500">
            Sie haben kein Kassenzeichen, oder Sie haben Probleme beim Anmelden?
            <a [routerLink]="['/kontakt']">Kontaktieren Sie uns</a>.
        </p>
    </form>
</div>
